import { render, staticRenderFns } from "./ProductFormSku.pug?vue&type=template&id=327002ae&scoped=true&lang=pug&"
import script from "./ProductFormSku.vue?vue&type=script&lang=js&"
export * from "./ProductFormSku.vue?vue&type=script&lang=js&"
import style0 from "./ProductFormSku.scss?vue&type=style&index=0&id=327002ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327002ae",
  null
  
)

export default component.exports